var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddImportContactBtnIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#1450ff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    rx: 2,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8,
    transform: "translate(12 8)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 8,
    transform: "translate(8 12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImportContactBtnIcon);
export default __webpack_public_path__ + "static/media/add-import-contact-btn-icon.73b701db90d540be6ffd353ce622001a.svg";
export { ForwardRef as ReactComponent };